import store from "../store";
import { setLocations } from "../store/devdocs/actions";

export const getAppParkingOrderLocations = async () => {
    const response = await fetch(`/.netlify/functions/get-app-parking-order-locations`, {
        method: 'POST'
    })
    const data = await response.json();
    store.dispatch(setLocations(data));
}